
import Vue from "vue";
import AppFileUpload from "@/components/FileUploadDropAndProgress.vue";
import { LedgerAccountService } from "@/services/ledger-account-service";

export default Vue.extend({
	data(){
		return {
			isUploading: false,
			file: null as null | File
		};
	},
	computed: {
		confirmDisabled():boolean{
			if (!this.file) {
				return true;
			}
			if (this.isUploading) {
				return true;
			}
			return false;
		},
		cancelDisabled():boolean{
			if (this.isUploading) {
				return true;
			}
			return false;
		}
	},
	methods: {
		onFile(file?:File){
			this.file = file || null;
		},
		onError(error:{message:string, data:any}){
			this.$wf.notify(error.message, "danger", 3000, "exclamation-triangle");
		},
		close(){
			this.$emit("close");
		},
		async confirm(){
			if (!this.file) return;
			try{
				this.isUploading = true;
				await LedgerAccountService.importCsv(this.file);
				this.$emit("fetch");
				this.close();
			}catch(err){

			}
			this.isUploading = false;
		}
	},
	components: {
		AppFileUpload
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
